import React from 'react';
import { RadialBarChart, RadialBar, Legend, ResponsiveContainer, PolarAngleAxis, Text } from 'recharts';

const COLORS = ['#2c285e', '#006fff', '#ff00cd'];

const MyRadial = ({ data }) => {
    return (
        <ResponsiveContainer width="100%" height={400}>
            <RadialBarChart innerRadius="10%" outerRadius="80%" data={data}  startAngle={90} endAngle={-270}>
                <PolarAngleAxis type="number" domain={[0, 100]} angleAxisId={0} tick={false} />
                {data.map((entry, index) => (
                    <RadialBar
                        key={`radial-bar-${index}`}
                        dataKey="value"
                        cornerRadius={10}
                        fill={COLORS[index % COLORS.length]}
                    />
                ))}
                <Legend iconSize={10} layout="vertical" verticalAlign="middle" align="right" />
                <Text x="50%" y="50%" textAnchor="middle" dominantBaseline="central" className="chart-number">
                    <tspan fontSize="30" fontWeight="bold">{data[0].total}</tspan>
                    <tspan fontSize="15" dy="20">salariés</tspan>
                </Text>
            </RadialBarChart>
        </ResponsiveContainer>
    );
};

export default MyRadial;
